
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      let selectedDate;
let roomDetails;
let roomNotes;
let room = '';
let reservation = '';
let occupation = '';
let roomProblems = [];
let systemIDDone = '';
let systemIDClean = '';
var filters = {
  All: true,
  Clean: false,
  Dirty: false,
  DNS: false
};
import '../dhtmlxscheduler_collision.js';
import '../css/new-calendar.css';
import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js";
export default {
  data() {
    return {
      CleanRooms: {},
      DirtyRooms: {},
      Rooms: {},
      serverTime: '',
      counter: 0,
      timer: null,
      RoomsByFloor: {},
      AllRoomsByFloor: {},
      selectedProblem: 0
    };
  },

  methods: {
    checkFilters: function (status) {
      let checkboxes = $$(".filter-checkbox-grid");
      let activeFilters = {
        FloorNames: [],
        Statuses: []
      };

      if (status && status != "All" && status.toLowerCase().indexOf("floor") === -1) {
        $$("#AllFilter-grid").prop('checked', false);
      }

      if (status && status != "All" && status.toLowerCase().indexOf("floor") === 0) {
        $$("#AllFloors-grid").prop('checked', false);
      }

      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          if (checkbox.value === "AllFloors") {
            activeFilters.FloorNames = ["AllFloors"];
            checkboxes.forEach(cb => {
              if (cb.value !== "AllFloors" && !["All", "Clean", "Dirty", "DNS"].includes(cb.value)) {
                cb.checked = false;
              }
            });
          } else if (!["All", "Clean", "Dirty", "DNS"].includes(checkbox.value)) {
            if (activeFilters.FloorNames.includes("AllFloors")) {
              activeFilters.FloorNames = [];
              checkboxes.forEach(cb => {
                if (cb.value === "AllFloors") {
                  cb.checked = false;
                }
              });
            }

            let matchingFloor = this.AllRoomsByFloor.find(floor => floor.Floor === parseInt(checkbox.value));

            if (matchingFloor) {
              activeFilters.FloorNames.push(matchingFloor.FloorName.toLowerCase());
            }
          } else if (checkbox.value === "All") {
            activeFilters.Statuses = ["All"];
            checkboxes.forEach(cb => {
              if (cb.value !== "All" && ["Clean", "Dirty", "DNS"].includes(cb.value)) {
                cb.checked = false;
              }
            });
          } else if (["Clean", "Dirty", "DNS"].includes(checkbox.value)) {
            if (activeFilters.Statuses.includes("All")) {
              activeFilters.Statuses = [];
              checkboxes.forEach(cb => {
                if (cb.value === "All") {
                  cb.checked = false;
                }
              });
            }

            activeFilters.Statuses.push(checkbox.value);
          }
        }
      });

      if (activeFilters.Statuses.length === 0) {
        activeFilters.Statuses = ["All"];
      }

      if (activeFilters.FloorNames.length === 0) {
        activeFilters.FloorNames = ["AllFloors"];
      }

      let RoomsByFloorFiltered = [];
      this.AllRoomsByFloor.forEach(floor => {
        let filteredRooms = floor.Rooms.filter(room => {
          if (activeFilters.Statuses.includes("All")) {
            return true;
          }

          if (activeFilters.Statuses.includes("Clean") && room.SysStatusID === 1) {
            return true;
          }

          if (activeFilters.Statuses.includes("Dirty") && room.SysStatusID === 2) {
            return true;
          }

          if (activeFilters.Statuses.includes("DNS") && room.SysStatusID !== 1 && room.SysStatusID !== 2) {
            return true;
          }

          return false;
        });
        let floorNameMatch = activeFilters.FloorNames.some(filterName => floor.FloorName.toLowerCase().includes(filterName));

        if (activeFilters.FloorNames.includes("AllFloors") || floorNameMatch) {
          if (filteredRooms.length > 0) {
            RoomsByFloorFiltered.push({
              Floor: floor.Floor,
              FloorName: floor.FloorName,
              Rooms: filteredRooms
            });
          }
        }
      });
      RoomsByFloorFiltered.sort((a, b) => a.Floor - b.Floor);
      this.$setState({
        RoomsByFloor: RoomsByFloorFiltered
      });
    },
    goToGridView: function () {
      this.$f7router.navigate('/dashboardKeeper/', {
        transition: 'f7-parallax'
      });
    },
    toggleFloor: function (elementId) {
      $(`#parent-${elementId}`).toggleClass("active-floor");
      $(`#${elementId}`).toggle();
    },

    handleRadioClick(status = '', counterType = '', counterValue = '') {
      this.SubmitRoomStatus(status);

      if (counterType !== '') {
        this.startCounter(counterType, counterValue);
      }
    },

    async SubmitRoomStatus(status) {
      let login = JSON.parse(localStorage.getItem('loginJson'));
      let propertyID = login.PropertyID;
      let userID = login.UserID;
      let roomID = $$('.modalHeaderContent').data('roomID');
      let selectedStatusID = '';

      if (status === 'Clean') {
        selectedStatusID = roomDetails[0].StatusList[0].Key;
      }

      if (status === 'Dirty') {
        selectedStatusID = roomDetails[0].StatusList[1].Key;
      }

      if (status === 'Inspected') {
        selectedStatusID = roomDetails[0].StatusList[2].Key;
      }

      if (status === 'Cleaning') {
        selectedStatusID = roomDetails[0].StatusList[3].Key;
      }

      await actions.SubmitRoomStatus(propertyID, userID, roomID, selectedStatusID, selectedDate.toLocaleDateString('en-GB'));
    },

    async sendReport(e) {
      let login = JSON.parse(localStorage.getItem('loginJson'));
      let propertyID = login.PropertyID;
      let userID = login.UserID;
      let roomID = $$('.modalHeaderContent').data('roomID');
      let reportMessage = $$('#reportMessage-grid').val();
      let problemCategoryID = this.selectedProblem;
      let priority = $$('#modalReportDropDown-grid').val();
      var problemID = $$(e.currentTarget).data('problemsID'); // await actions.SubmitRoomProblem(propertyID, userID, problemCategoryID, roomID, reportMessage, priority);

      await actions.SubmitRoomProblem(propertyID, userID, problemID, problemCategoryID, roomID, reportMessage, priority);
      this.$f7.popup.close('.popup-report-grid');
      this.getRoomDetails(room, reservation, occupation);
    },

    SetProblemID(id) {
      $$("#send-report-button-grid").attr("data-problemsID", id);
    },

    SetNoteID(ID) {
      if (ID == 0) {
        $$("#noteMessage-grid").val("");
      }
    },

    async sendProblem(e) {
      let login = JSON.parse(localStorage.getItem('loginJson'));
      let propertyID = login.PropertyID;
      let userID = login.UserID;
      let roomID = $$('.modalHeaderContent').data('roomID');
      let reportMessage = $$('#problemMessage').val();
      let problemCategoryID = this.selectedProblem;
      let priority = $$('#modalReportDropDown-grid').val();
      var problemID = $$(e.currentTarget).data('problemsID');
      await actions.SubmitRoomProblem(propertyID, userID, problemID, problemCategoryID, roomID, reportMessage, priority);
      this.$f7.popup.close('.popup-report-grid');
      this.getRoomDetails(room, reservation, occupation);
    },

    async sendNote() {
      let login = JSON.parse(localStorage.getItem('loginJson'));
      let propertyID = login.PropertyID;
      let userID = login.UserID;
      let roomID = $$('.modalHeaderContent').data('roomID');
      let reportMessage = $$('#noteMessage-grid').val();
      $$('#noteMessage-grid').val('');
      let reservationID = $$('#roomStatus-grid').data('reservation');
      let noteID = $$('#noteBtn').data('noteID') || '0';
      await actions.SubmitRoomNote(propertyID, userID, roomID, reservationID, noteID, reportMessage);
      this.$f7.popup.close('.popup-note-grid');
      this.getRoomDetails(room, reservation, occupation);
    },

    async startCounter(mode, selected = '') {
      let login = JSON.parse(localStorage.getItem('loginJson'));
      let propertyID = login.PropertyID;
      let userID = login.UserID;
      let roomID = $$('.modalHeaderContent').data('roomID');
      let selectedStatusID = '';

      if (selected === 'clean') {
        selectedStatusID = roomDetails[0].StatusList[0].Key;
      }

      if (selected === 'done') {
        selectedStatusID = roomDetails[0].StatusList[2].Key;
      }

      if (selected === 'cleaning') {
        selectedStatusID = roomDetails[0].StatusList[3].Key;
      }

      const currentDate = new Date(); // Get individual components

      const year = currentDate.getFullYear(); // 4-digit year

      const month = currentDate.getMonth() + 1; // Month (0-indexed, so add 1)

      const day = currentDate.getDate(); // Day of the month

      const hours = currentDate.getHours(); // Hours (0-23)

      const minutes = currentDate.getMinutes(); // Minutes (0-59)

      const seconds = currentDate.getSeconds();
      let date = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

      if (mode !== 'start') {
        await actions.EndWork(propertyID, userID, roomID, date, selectedStatusID);
        clearInterval(this.timer);
      } else {
        await actions.StartWork(propertyID, userID, roomID, date); // Reset the counter

        this.counter = roomDetails[0].TotalSeconds ? roomDetails[0].TotalSeconds : 0;

        try {
          clearInterval(this.timer);
        } catch (error) {} // Start the timer


        this.timer = setInterval(() => {
          this.counter++;
          const hours = Math.floor(this.counter / 3600);
          const minutes = Math.floor(this.counter % 3600 / 60);
          const seconds = this.counter % 60;
          let timer = `${this.pad2(hours)}:${this.pad2(minutes)}:${this.pad2(seconds)}`;
          $$('.modalTimer').html(timer);
        }, 1000);
      }
    },

    SetProblemStatusID(sID) {
      const ID = parseInt(sID);
      $$(".problem-logo-wrapper").removeClass("selected-problem");

      if (ID !== 0) {
        $('*[data-selectionid="' + ID + '"]').closest('.problem-logo-wrapper').addClass("selected-problem");
      } else {
        this.SetProblemID(0);
        $$("#reportMessage-grid").val("");
        $$('#modalReportDropDown-grid').val(1);
      }
    },

    timeToSeconds(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      const remainingSeconds = seconds % 60;
      const formattedHours = this.pad2(hours);
      const formattedMinutes = this.pad2(minutes);
      const formattedSeconds = this.pad2(remainingSeconds);
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    },

    pad2(num) {
      return num.toString().padStart(2, '0');
    },

    pad(value) {
      // Add leading zero to single-digit numbers
      return value < 10 ? `0${value}` : value;
    },

    getRoomDetails: async function (roomID, reservationID, roomOccupation) {
      room = roomID;
      reservation = reservationID;
      occupation = roomOccupation;
      let login = JSON.parse(localStorage.getItem('loginJson'));
      let propertyID = login.PropertyID;
      let userID = login.UserID;
      roomDetails = await actions.GetHousekeepingRoomDetails(propertyID, selectedDate.toLocaleDateString('en-GB'), userID, roomID, reservationID);

      if (roomDetails.length === 0) {
        return;
      }

      let noteHTML = '';
      let adultHTML = '<i class="f7-icons" style="font-size: 16px;">person_fill</i>';
      let childrenHTML = '<i class="f7-icons" style="font-size: 14px;">person</i>';
      $$('#adultsIcons-grid').empty();
      $$('#childrenIcons-grid').empty();

      for (let i = 0; i < roomDetails[0].Adults; i++) {
        $$('#adultsIcons-grid').append(adultHTML);
      }

      for (let i = 0; i < roomDetails[0].Children; i++) {
        $$('#childrenIcons-grid').append(childrenHTML);
      }

      $$('#startStopWork-grid').data('roomID', roomDetails[0].RoomID);
      $$('.modalHeaderContent').data('roomID', roomDetails[0].RoomID);
      $$('#customerName-grid').html(roomDetails[0].customerName || '');
      $$('#roomName-grid').html('Room ' + roomDetails[0].RoomName || '');
      $$('#roomOccupation-grid').html(roomOccupation);
      $$('#roomStatus-grid').prop('checked', roomDetails[0].DND || '');
      $$('#roomStatus-grid').data('reservation', reservationID || '');
      $$('#roomStatus-grid').data('propertyID', propertyID || '');

      if (!reservationID || reservationID == "0") {
        $$('#roomStatus-grid').parent().closest('label').addClass("no-touching");
      }

      $$('#radioDirty-grid').prop('checked', false);
      $$('#radioCleaning-grid').prop('checked', false);
      $$('#radioClean-grid').prop('checked', false);
      $$('#radioDone-grid').prop('checked', false);

      if (roomDetails[0].SysStatusID === 1) {
        $$('#radioClean-grid').prop('checked', true);
      } else if (roomDetails[0].SysStatusID === 2) {
        $$('#radioDirty-grid').prop('checked', true);
      } else if (roomDetails[0].SysStatusID === 3) {
        $$('#radioDone-grid').prop('checked', true);
      } else {
        $$('#radioCleaning-grid').prop('checked', true);
      }

      let CurrentNight = roomDetails[0]?.CurrentNight ? roomDetails[0]?.CurrentNight : 0;
      $$('#reservationDates-grid').html(CurrentNight + '/' + roomDetails[0]?.Nights + ' nights' || '');
      $$('#checkInDate-grid').html('<i class="f7-icons">square_arrow_right</i>' + roomDetails[0].CheckIn || '');
      $$('#checkOutDate-grid').html(roomDetails[0].CheckOut + '<i class="f7-icons">square_arrow_right</i>' || '');
      $$(".modalFirstSegment").show();

      if (!reservationID || reservationID == "0") {
        $$(".modalFirstSegment").hide();
      }

      roomNotes = await actions.GetHousekeepingNotes(propertyID, selectedDate.toLocaleDateString('en-GB'), userID, roomID, reservationID);
      $$('#allNotes-grid').empty();

      for (let i = 0; i < roomNotes[0].TheNotes.length; i++) {
        let editHTML = '';

        if (roomNotes[0].TheNotes[i].CanEdit) {
          editHTML = `<span class="popup-open edit-Btn-class" data-noteid="${i}" data-popup=".popup-note-grid"><a class="link" href="#">Edit</a></span>`;
        }

        noteHTML = `<div class="card modalNoteCard">
                        <div class="card-content card-content-padding ">
                          <li class="item-content modalNoteContent">
                            <div class="row">
                              <div class="col-70 modalNoteTitle">
                                <div>
                                  ${editHTML}
                                </div>
                              </div>
                              <div class="col-30" id="roomNumberID">
                                <div style="display: flex;flex-direction: column;">
                                  <span style="font-weight: 600;">${roomNotes[0].TheNotes[i].User || ''}</span>
                                  <span>Added ${roomNotes[0].TheNotes[i].NotificationDateStr || ''}</span>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-100 reservcode" style="display:flex;">
                                ${roomNotes[0].TheNotes[i].NotificationText || ''}
                              </div>
                            </div>
                          </li>
                        </div>
                      </div>`;
        $$('#allNotes-grid').append(noteHTML);
      }

      roomProblems = await actions.GetHousekeepingRoomProblems(propertyID, userID, roomID, selectedDate.toLocaleDateString('en-GB'));
      roomProblems = JSON.parse(roomProblems.data);
      $$('#allProblems-grid').empty();
      let problemHTML = '';
      let priority = '';

      for (let i = 0; i < roomProblems[0].Problems.length; i++) {
        let editHTML = '';

        if (roomProblems[0].Problems[i].CanEdit) {
          editHTML = `<span class="popup-open edit-Btn-class-problem" data-problemIndex="${i}" data-problemsID="${roomProblems[0].Problems[i].ProblemID}" data-popup=".popup-report-grid"><a class="link" href="#">Edit</a></span>`;
          editHTML += `<div class="fix-problem" data-problemsID="${roomProblems[0].Problems[i].ProblemID}">Fix<span class="icon f7-icons material-icons fix-icon">wrench</span></div>`;
        }

        if (roomProblems[0].Problems[i].Priority === 1) {
          priority = 'High';
        } else if (roomProblems[0].Problems[i].Priority === 2) {
          priority = 'Medium';
        } else {
          priority = 'Low';
        }

        problemHTML = `<div class="card modalNoteCard">
                <div class="card-content card-content-padding ">
                  <li class="item-content modalNoteContent">
                    <div class="row">
                      <div class="col-70 modalNoteTitle">
                        <div>
                          ${editHTML}
                        </div>
                      </div>
                      <div class="col-30" id="roomNumberID_${roomProblems[0].Problems[i].ProblemID}">
                        <div style="display: flex;flex-direction: column;">
                          <span style="font-weight: 600;">${roomProblems[0].Problems[i].User || ''}</span>
                          <span>Added ${roomProblems[0].Problems[i].InsertDateStr || ''}</span>
                          <span>Priority ${priority}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-100 reservcode" style="display:flex;">
                        ${roomProblems[0].Problems[i].Description || ''}
                      </div>
                    </div>
                  </li>
                </div>
              </div>`;
        $$('#allProblems-grid').append(problemHTML);
      }

      let timer = roomDetails[0].TotalSeconds ? this.timeToSeconds(roomDetails[0].TotalSeconds) : this.timeToSeconds(0);
      $$('.modalTimer').html(timer || '00:00:00');
      $$('.edit-Btn-class').on('click', e => {
        var noteIDCheck = $$(e.currentTarget).data('noteid');
        let text = roomNotes[0].TheNotes[noteIDCheck].NotificationText;
        $$('#noteMessage-grid').val(text);
      });
      $$('.edit-Btn-class-problem').on('click', e => {
        var problemIndex = $$(e.currentTarget).data('problemIndex');
        var $select = $$('#modalReportDropDown-grid'); // Set the selected option based on priority

        if (roomProblems[0].Problems[problemIndex].Priority === 1) {
          $select.val('1');
        } else if (roomProblems[0].Problems[problemIndex].Priority === 2) {
          $select.val('2');
        } else {
          $select.val('3');
        } // if (roomProblems[0].Problems[problemIndex].Priority === 1) {
        //     $('select>option:eq(0)').prop('selected', true);
        // } else if (roomProblems[0].Problems[problemIndex].Priority === 2) {
        //     $('select>option:eq(1)').prop('selected', true);
        // } else {
        //     $('select>option:eq(2)').prop('selected', true);
        // }


        let text = roomProblems[0].Problems[problemIndex].Description;
        let ProblemCategoryID = roomProblems[0].Problems[problemIndex].ProblemCategoryID;
        $$('#reportMessage-grid').val(text);
        const problemID = $$(e.currentTarget).data('problemsID');
        this.SetProblemID(problemID);
        this.SetProblemStatusID(ProblemCategoryID);
      });
      $$('.fix-problem').on('click', e => {
        const problemID = $$(e.currentTarget).data('problemsID');
        this.FixRoomProblem(problemID);
      }); // setTimeout(() => {
      //     $$('.popup-note-grid').on('popup:closed', (e) => {
      //         this.getRoomDetails(room, reservation, occupation);
      //     });
      // }, 2000);
    },
    FixRoomProblem: async function (problemID) {
      let obj = {
        ProblemID: problemID,
        StatusID: 2
      };
      app.f7.preloader.show();
      await app.f7.request.promise.post(URLS.FixRoomProblem, {
        obj
      }).then(res => {
        app.f7.preloader.hide();
      });
      this.getRoomDetails(room, reservation, occupation);
    },
    selectItem: function () {
      let element = event.target;
      let elementParent = event.target.parentNode;
      $$('.selector').forEach(thisElement => {
        // element.style.background = 'transparent';
        $$(thisElement).closest('.problem-logo-wrapper').removeClass("selected-problem");
      }); // element.style.background = '#5764EE';

      elementParent.parentNode.classList.add("selected-problem");
      const selectedProblem = elementParent.getAttribute('data-selectionID');
      this.$setState({
        selectedProblem: selectedProblem
      });
    },
    updateUI: async function (date) {
      let RoomsList = await actions.GetKeeperRooms(date);
      const RoomsByFloor = [];
      RoomsList.forEach(room => {
        let floorData = RoomsByFloor.find(floor => floor.Floor === room.Floor);

        if (!floorData) {
          floorData = {
            Floor: room.Floor,
            FloorName: room.FloorName,
            Rooms: []
          };
          RoomsByFloor.push(floorData);
        }

        if (room?.hasProblems) {
          room.icon = "warning";
          room.iconSecondary = "warning";
          room.class = "warning";
          room.Status = "Reported problem";
        } else if (room.SysStatusID === 2) {
          room.icon = "do_not_disturb_on";
          room.class = "dirty";
          room.Status = "Dirty";
        } else if (room.SysStatusID === -1) {
          room.icon = "schedule";
          room.class = "schedule";
          room.Status = "To-Do";
        } else if (room.SysStatusID === 1) {
          room.icon = "check_circle";
          room.class = "clean";
          room.Status = "Clean";
        } else if (room.SysStatusID === 3) {
          room.icon = "new_releases";
          room.class = "done";
          room.Status = "Done";
        } else if (room.SysStatusID === 4) {
          room.icon = "av_timer";
          room.class = "inprogress";
          room.Status = "In Progress";
        }

        floorData.Rooms.push({
          RoomName: room.RoomName,
          Status: room.Status,
          ExtraInfo: room.ExtraInfo,
          Housekeeper: room.Housekeeper,
          RoomID: room.RoomID,
          ReservationID: room.ReservationID,
          icon: room.icon,
          iconSecondary: room?.iconSecondary,
          hasNotes: room?.hasNotes,
          hasProblems: room?.hasProblems,
          SysStatusID: room.SysStatusID,
          StatusID: room.StatusID,
          ExtraInfoID: room.ExtraInfoID,
          class: room.class,
          ReservationName: room.ReservationName
        });
      });
      RoomsByFloor.forEach(floor => {
        floor.FloorName = floor.FloorName.replace(/[^a-zA-Z0-9 ]/g, "").trim(); // Remove special characters and trim spaces
      });
      RoomsByFloor.sort((a, b) => a.Floor - b.Floor);
      console.log(RoomsByFloor);
      this.$setState({
        RoomsByFloor: RoomsByFloor,
        AllRoomsByFloor: RoomsByFloor
      });
      this.checkFilters();
    }
  },

  beforeDestroy() {
    // Clear the timer when the component is destroyed
    clearInterval(this.timer);
  },

  on: {
    pageInit: async function (e, page) {
      var self = this;
      var $ = self.$;
      let calendarRangeFrom3;

      let moment = require('moment');

      let today = moment();
      calendarRangeFrom3 = app.f7.calendar.create({
        inputEl: '#plan-calendar-From-grid',
        dateFormat: 'D,M dd',
        date: today,
        value: [new Date()],
        closeOnSelect: true,
        on: {
          change: function (c) {
            let CalendarDate = c.value;
            selectedDate = new Date(CalendarDate[0]);
            self.updateUI(selectedDate);
          }
        }
      });
      $$('#roomStatus').on('click', async () => {
        let reservationID = $$('#roomStatus').data('reservation');
        let propertyID = $$('#roomStatus').data('propertyID');
        let checkboxStatus;

        if ($$('#roomStatus').prop('checked')) {
          checkboxStatus = 1;
        } else {
          checkboxStatus = 0;
        }

        let toggleDND = await actions.ToggleDoNotDisturb(propertyID, reservationID, checkboxStatus);
      });
      $$('.popup-about-grid').on('popup:closed', function (e) {
        self.updateUI(selectedDate);
      });
      $$('.popup-note-grid').on('popup:closed', function (e) {
        $(".popup-backdrop").addClass('backdrop-in');
      });
      $$('.popup-report-grid').on('popup:closed', function (e) {
        $(".popup-backdrop").addClass('backdrop-in');
      });
    }
  },
  id: '24af6fdccf',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div id=page class=page style="background-color: #f7f7f7" data-name=dashboardKeeperGrid><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding" style="background: white;color: black;"><div class=left><!-- <a href="#" class="link back">\n                        <i class="icon icon-back" style="color: black"></i>\n                    </a> --></div><div class="title sliding" style="width: 100%;display: flex;justify-content: space-between;align-items: center;margin-right:0;"><div class=title-date-wrapper><input name=checkInDate-grid class=dhx_cal_date type=text readonly=readonly id=plan-calendar-From-grid> <i class="icon material-icons">arrow_drop_down</i></div><!-- <div class="card-content card-content-padding" @click="goToGridView">\n                        <i class="icon f7-icons material-icons">table_rows</i>\n                    </div> --><div class="card-content card-content-padding" @click=goToGridView><a href=# class="link back"><i class="icon icon-back" style="color: black"></i></a></div><div class="card-content card-content-padding panel-open" data-panel=#panel-nested-grid><i class="icon f7-icons material-icons">square_list</i></div></div></div></div><div class="panel panel-right panel-cover panel-init" id=panel-nested-grid data-container-el=#panel-page><div class=page><div class="block block-strong-ios block-outline-ios"><a class="panel-close filter-panel-header"><div>Filters</div><i class="icon f7-icons material-icons">clear</i></a><div class="list list-strong-ios list-outline-ios list-dividers-ios"><ul style="overflow-y: auto;max-height: calc(100vh - 100px);"><li><label class="item-checkbox item-checkbox-icon-start item-content"><input type=checkbox class=filter-checkbox-grid name=demo-checkbox value=AllFloors id=AllFloors-grid checked=checked @click="checkFilters(\'AllFloors\')"> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>All Floors</div></div></label></li>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.AllRoomsByFloor, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li><label class="item-checkbox item-checkbox-icon-start item-content"><input type=checkbox class=filter-checkbox-grid name=demo-checkbox value=';
          r += c(ctx_2.Floor, ctx_2);
          r += ' @click="checkFilters(\'floor\')"> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>Floor: ';
          r += c(ctx_2.FloorName, ctx_2);
          r += '</div></div></label></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<li><label class="item-checkbox item-checkbox-icon-start item-content"><input type=checkbox class=filter-checkbox-grid name=demo-checkbox value=All id=AllFilter-grid checked=checked @click="checkFilters(\'All\')"> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>All Statuses</div></div></label></li><li><label class="item-checkbox item-checkbox-icon-start item-content"><input type=checkbox class=filter-checkbox-grid name=demo-checkbox value=Clean id=CleanFilter-grid @click="checkFilters(\'Clean\')"> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>Clean</div></div></label></li><li><label class="item-checkbox item-checkbox-icon-start item-content"><input type=checkbox class=filter-checkbox-grid name=demo-checkbox value=Dirty id=DirtyFilter-grid @click="checkFilters(\'Dirty\')"> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>Dirty</div></div></label></li><li><label class="item-checkbox item-checkbox-icon-start item-content"><input type=checkbox class=filter-checkbox-grid name=demo-checkbox value=DNS id=DNSFilter-grid @click="checkFilters(\'DNS\')"> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>DNS</div></div></label></li></ul></div></div></div></div><div class=page-content style="padding-bottom: 0px"><div><!-- <div class="modalHeader">\n                    <p>\n                        <a class="link popup-close" href="#"><i class="f7-icons">arrow_left</i></a>\n                    </p> \n                    <div data-roomID="" class="modalHeaderContent">\n                        <div class="modalHeaderTitle">Work allocation</div>\n                    </div>\n                </div> --><div class=grid-wrapper>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.RoomsByFloor, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=grid-wrapper-inner><div class=grid-floor-label>Floor: ';
          r += c(ctx_2.FloorName, ctx_2);
          r += '</div><div class=grid-floor-rooms>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Rooms, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class="grid-cell popup-open" data-popup=.popup-about-grid @click="getRoomDetails(\'';
              r += c(ctx_3.RoomID, ctx_3);
              r += '\', \'';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '\',\'';
              r += c(ctx_3.ExtraInfo, ctx_3);
              r += '\')"><div class=grid-cell-inner><span>';
              r += c(ctx_3.RoomName, ctx_3);
              r += '</span></div><div class=grid-bottom-icons>';
              r += Template7Helpers.if.call(ctx_3, ctx_3.hasProblems, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <i class="icon material-icons">build</i> ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.hasNotes, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <i class="icon material-icons">mode_comment</i> ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div><div class="grid-status ';
              r += c(ctx_3.class, ctx_3);
              r += '">';
              r += c(ctx_3.Status, ctx_3);
              r += '</div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="popup popup-about-grid"><div><div class=modalHeader><p><a class="link popup-close" href=#><i class=f7-icons>arrow_left</i></a></p><div data-roomid="" class=modalHeaderContent><div style="display: flex;width: 100%;flex-direction: column;align-items: center;"><div class=modalHeaderTitle id=roomName-grid></div><div class=modalHeaderStatus id=roomOccupation-grid></div></div><div class=modalHeaderBar></div><div class=modalHeaderLeft style="display: flex;width: 100%;align-items: center;"><div style="display: flex;flex-direction: column;align-items: flex-start;"><div class=modalHeaderName id=customerName-grid></div><div style="display: flex"><div id=adultsIcons-grid></div><div class=modalHeaderSmallBar></div><div id=childrenIcons-grid></div></div></div></div></div></div><div style="overflow: scroll; height: calc(100vh - 56px)"><div class=modalFirstSegment><div><button class="col button button-fill" @click=startCounter data-roomid="" id=startStopWork-grid style="display: none"></button><div class=modalNights id=reservationDates-grid></div></div><div class=modalBlackBar></div><div class=modalDatesSegment><div class=modalDate id=checkInDate-grid></div><div class=modalDate id=checkOutDate-grid></div></div></div><div class=modalSecondSegment><div class=modalTimer><span>';
      r += c(ctx_1.formattedTime, ctx_1);
      r += '</span></div></div><div style="border-bottom: 1px solid #c9c8c8"><div class=modalDoNotDisturb><div class=modalDoNotDisturbRight><i class=f7-icons style="margin-right: 5px;color: #ff5e00;font-size: 25px;">lock_open</i> <span style="font-size: 16px">Do Not Disturb</span></div><label class="toggle toggle-init color-black"><input type=checkbox data-propertyid="" data-reservation="" id=roomStatus-grid> <span class=toggle-icon></span></label></div></div><div style="padding: 10px 0;border-bottom: 1px solid #c9c8c8"><div class="custom-radio modalRadioPink"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Dirty id=radioDirty-grid @click="handleRadioClick(\'Dirty\');"> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Dirty</div></div></label></div><div class="custom-radio modalRadioOrange"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Cleaning id=radioCleaning-grid @click="handleRadioClick(\'Cleaning\',\'start\',\'cleaning\');"> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Cleaning / In Progress</div></div></label></div><div class="custom-radio modalRadioLightBlue"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Clean id=radioClean-grid @click="handleRadioClick(\'Clean\',\'end\',\'clean\');"> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Clean</div></div></label></div><div class="custom-radio modalRadioPurple"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Done id=radioDone-grid @click="handleRadioClick(\'Inspected\',\'end\',\'done\');"> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Done / Inspected</div></div></label></div></div><div style="border-bottom: 1px solid #c9c8c8"><div class="modalReportSegment popup-open" data-popup=.popup-report-grid @click="SetProblemStatusID(\'0\')"><div style="display: flex; align-items: center"><i class=f7-icons>exclamationmark_triangle_fill</i> <span class=modalReport>Report a Problem</span></div><i class=f7-icons>chevron_right</i></div></div><div style="border-bottom: 1px solid #c9c8c8"><div style="display: flex; align-items: center"><span style="font-size: 16px;margin: 15px 10px;">Housekeeping Problems</span></div><div id=allProblems-grid></div></div><div style="margin: 10px"><div style="display: flex; align-items: center"><span style="font-size: 18px">Notes Housekeeping</span><p style="margin:0 10px" class=popup-open data-popup=.popup-note-grid @click=SetNoteID(0)><a class=link href=#><i class=f7-icons>plus_bubble_fill</i></a></p></div><div id=allNotes-grid></div></div></div></div></div><div class="popup popup-note-grid"><div><div class=modalHeader><p style="margin-left: 10px"><a class="link popup-close" href=#><i class=f7-icons>arrow_left</i></a></p><div style="font-size: 16px;margin-left: -20px;">Note Housekeeping</div><div class=modalHeaderLeft></div></div><div style="overflow: scroll; height: calc(100vh - 56px)"><div style="padding: 0 20px;"><div>Leave a Note</div><div><div class=item-inner><div class=item-input-wrap><textarea style="width: 100%; height: 100px;border: 1px solid #b1aeae;margin: 10px 0;" id=noteMessage-grid placeholder="Write here your message"></textarea></div></div></div><div><button @click=sendNote id=noteBtn data-noteid="" class="col button button-fill">Send</button></div></div></div></div></div><div class="popup popup-report-grid"><div><div class=modalHeader><p style="margin-left: 10px"><a class="link popup-close" href=#><i class=f7-icons>arrow_left</i></a></p><div style="width: 100%;text-align: center;">Report a problem</div><!-- <div class="modalHeaderLeft">\n                            <p style="margin-right: 10px">\n                                <a class="link popup-close" href="#"><i\n                                        class="f7-icons">checkmark_alt_circle_fill</i></a>\n                            </p>\n                        </div> --></div><div style="overflow: scroll; height: calc(100vh - 56px);padding: 0px 10px;"><div><div style="padding: 5px 0px;">Select category</div><div style="display: flex; justify-content: space-evenly"><div class=problem-wrapper><div class=problem-logo-wrapper><div @click=selectItem class=selector data-selectionid=1><img class=problemLogoclass src=./static/images/bathroom.png></div></div><div>Bathroom</div></div><div class=problem-wrapper><div class=problem-logo-wrapper><div @click=selectItem class=selector data-selectionid=2><img class=problemLogoclass src=./static/images/hanger.png></div></div><div>Door Lock</div></div><div class=problem-wrapper><div class=problem-logo-wrapper><div @click=selectItem class=selector data-selectionid=3><img class=problemLogoclass src=./static/images/heating.png></div></div><div>Heating</div></div></div><div style="display: flex; justify-content: space-evenly"><div class=problem-wrapper><div class=problem-logo-wrapper><div @click=selectItem class=selector data-selectionid=4><img class=problemLogoclass src=./static/images/lights.png></div></div><div>Lights</div></div><div class=problem-wrapper><div class=problem-logo-wrapper><div @click=selectItem class=selector data-selectionid=5><img class=problemLogoclass src=./static/images/tv.png></div></div><div>TV</div></div><div class=problem-wrapper><div class=problem-logo-wrapper><div @click=selectItem class=selector data-selectionid=6><img src=./static/images/question.png alt="" style="max-width: 60px"></div></div><div>Other</div></div></div><div class=item-inner style="border-top: 1px solid #c9c8c8;margin-top: 30px;padding-top: 10px;"><div style="padding: 0px 20px;"><div class="item-title item-label">Priority</div><div class="item-input-wrap input-dropdown-wrap"><select id=modalReportDropDown-grid><option value=1>High</option><option value=2>Medium</option><option value=3>Low</option></select></div></div></div></div><div style="padding: 0px 20px;"><div>Add Description (Optional)</div><div><div class=item-inner><div class=item-input-wrap><textarea style="width: 100%; height: 100px;border: 1px solid #b1aeae;margin: 10px 0;" id=reportMessage-grid placeholder="Write here your message"></textarea></div></div></div><div><button @click=sendReport id=send-report-button-grid data-problemsid=0 class="col button button-fill">Send</button></div></div></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .popup.popup-about-grid,
    .popup.popup-note-grid,
    .popup.popup-report-grid {
        top: 50px;
    }

    .md label.item-radio {
        display: flex;
    }

    .fix-icon {
        font-size: 18px;
        margin-left: 5px;
    }

    .no-touching {
        pointer-events: none;
    }

    .filter-panel-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
    }

    .problem-logo-wrapper.selected-problem {
        background: #5764EE;
    }

    .problem-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .problem-logo-wrapper {
        max-height: 100px;
        height: 70px;
        width: 70px;
        border-radius: 50px;
        border: 2px solid gray;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .problemLogoclass {
        height: 2rem
    }

    .custom-floating .fab-buttons-top {
        left: 33%;
    }

    .custom-floating .fab-label-button {
        display: flex;
        justify-content: center;
        width: 70px;
    }

    .grid-bottom-icons {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-right: 12px;
        margin-bottom: 5px;
    }

    .grid-cell .grid-bottom-icons i {
        color: black;
        font-size: 16px;
        margin-left: 6px;
    }

    .grid-cell-inner {
        height: 60px;
        display: flex;
        align-items: flex-end;
        font-size: 30px;
        font-weight: 400;
        width: 80%;
        color: black;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
    }

    .grid-cell-inner span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .grid-wrapper-inner {
        padding-bottom: 15px;
    }

    .grid-status {
        padding: 2px 5px;
        margin-bottom: 3px;
        border-radius: 9px;
    }

    .grid-status.warning {
        background: #f7cd00;
    }

    .grid-status.schedule {
        background: #b3b3b3;
    }

    .grid-status.dirty {
        background: #ff5c1c;
    }

    .grid-status.clean {
        background: #18d5cc;
    }

    .grid-status.done {
        background: #7c7ec0;
    }

    .grid-status.inprogress {
        background: #bdb172;
    }

    .grid-floor-rooms {
        display: flex;
        flex-wrap: wrap;
    }

    .grid-cell {
        width: 29%;
        height: 100px;
        margin: 5px;
        display: flex;
        border-radius: 8px;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        border: 1px solid black;
    }

    .grid-floor-label {
        /* background: #0f3874; */
        padding: 5px;
        color: black;
        border-radius: 8px;
    }

    .grid-wrapper {
        padding: 10px;
        overflow-y: auto;
        max-height: calc(100vh - 100px);
    }

    .clean {
        background: #caf3f1;
    }

    .clean i {
        color: #18d5cc;
    }

    .warning {
        background: #f3ecca;
    }

    .warning .custom-badge {
        background: #a98c00;
    }

    .warning i {
        color: #f7cd00;
    }

    .modalNoteCard .card-content-padding {
        padding: 0 10px;
    }

    .md .custom-radio label.item-radio-icon-end input[type="radio"]~.icon-radio {
        position: absolute;
        top: 50%;
        margin-top: -10px;
        right: calc(var(--f7-safe-area-right) + 0px);
    }

    .md .custom-radio label .item-inner .item-title {
        font-weight: 600;
        font-size: 15px;
    }

    .custom-room-card {
        width: 100%;
        border-radius: 10px;
        margin: 5px;
    }

    .active-floor {
        font-weight: 700;
        color: black;
    }

    .title-date-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 20px;
        width: 100%;
    }

    .dhx_cal_container {
        font-family: 'Open Sans';
    }

    #plan-calendar-From-grid {
        width: 100px;
        height: 40px;
        border: none;
        font-size: 16px;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 7px 0 0;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 7px;
    }

    @media (max-width: 1440px) {

        .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 9px 0 0;
        }

        .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 9px;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 5px 0 0;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 5px;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 7px 0 0;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 7px;
        }
    }

    .CustEventShape_1 .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
        border-bottom-color: transparent !important;
        border-right-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_1 .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_2 .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 0 30px 18px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
    }

    .CustEventShape_2 .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 18px 30px 0;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.schType_undefined:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
        border-width: 30px 0 30px 34px;
        right: -35px;
    }

    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 34px 30px 0;
        left: -35px;
    }

    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
        border-width: 30px 0 30px 13px;
        right: -14px;
    }

    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 13px 30px 0;
        left: -14px;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 7px 0 0;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 7px;
    }

    @media (max-width: 1440px) {

        .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 9px 0 0;
        }

        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 9px;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 5px 0 0;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 5px;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 7px 0 0;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 7px;
        }

        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.schType_undefined:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
            border-width: 30px 0 30px 15px;
            right: -16px;
        }

        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 30px 15px 30px 0;
            left: -16px;
        }
    }

    .EC_Deposit .schdResIcons:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: '';
    }

    .EC_Paid .schdResIcons:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: '';
    }

    .subnavbar {
        position: fixed;
        z-index: 9000;
    }

    .row .col-30 {
        --f7-cols-per-row: none;
    }

    .tabBadge {
        border-radius: 10px !important;
        position: absolute;
    }

    .modalHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* border-bottom: #c9c8c8; */
        width: 100%;
        box-shadow: rgb(0 0 0 / 20%) 0px 3px 6px;
    }

    .modalHeaderContent {
        display: flex;
        justify-content: space-around;
        width: 100%;
        align-items: center;
        padding: 10px 0;
    }

    .modalHeaderTitle {
        font-size: 18px;
        color: black;
        font-weight: 600;
    }

    .modalHeaderStatus {
        font-size: 13px;
        font-weight: 500;
        color: darkgray;
    }

    .modalHeaderBar {
        background-color: #cdcccc;
        height: 40px;
        width: 2px;
    }

    .modalHeaderSmallBar {
        background-color: #10bfbf;
        height: auto;
        width: 2px;
    }

    .modalHeaderLeft {
        flex-direction: column;
        align-items: flex-start;
    }

    .modalHeaderName {
        font-size: 14px;
        font-weight: 500;
        color: darkgray;
    }

    .modalFirstSegment {
        display: flex;
        flex-direction: column;
        align-items: center;
        border-bottom: #c9c8c8;
        padding-top: 5px;
    }

    .modalNights {
        font-size: 15px;
        font-weight: 500;
        margin: 3px 0px;
    }

    .modalBlackBar {
        background-color: black;
        height: 5px;
        width: 90%;
        border-radius: 5px;
    }

    .modalDatesSegment {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .modalDate {
        display: flex;
        align-items: center;
        margin: 10px 19px 10px 18px;
    }

    .modalSecondSegment {
        border-bottom: #c9c8c8;
        display: flex;
        align-items: center;
    }

    .modalTimer {
        font-size: 25px;
        transform: translate(-50%);
        left: 50%;
        position: relative;
        font-weight: 500;
        padding: 10px 0;
    }

    .modalDoNotDisturb {
        display: flex;
        justify-content: space-between;
        margin: 20px;
    }

    .modalDoNotDisturbRight {
        display: flex;
        align-items: center;
        flex-direction: row;
    }

    .modalRadioPink {
        background: #ffdbdf;
        border-radius: 10px;
        margin: 10px 20px 10px 20px;
        padding: 10px;
    }

    .modalRadioOrange {
        background: #f8f2d2;
        border-radius: 10px;
        margin: 0px 20px 10px 20px;
        padding: 10px;
    }

    .modalRadioLightBlue {
        background: #e4f4f4;
        border-radius: 10px;
        margin: 0px 20px 10px 20px;
        padding: 10px;
    }

    .modalRadioPurple {
        background: #dddefa;
        border-radius: 10px;
        margin: 0px 20px 10px 20px;
        padding: 10px;
    }

    .modalReportSegment {
        display: flex;
        justify-content: space-between;
        margin: 15px 10px;
        align-items: center;
    }

    .modalReport {
        font-size: 16px;
        font-weight: 500;
        margin: 10px;
    }

    .modalNoteCard {
        border: 1px solid #a5a5a5;
        border-width: thin;
        border-radius: 10px;
        margin: 20px 10px;
    }

    .modalNoteCard:first-child {
        margin: 10px 10px;
    }

    .modalNoteContent {
        display: block;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .modalNoteTitle {
        font-weight: 600;
        font-size: 15px;
    }
`,
  styleScoped: false
};
    